<template>
    <div v-if="timers.length > 0" class="mt-7 md:hidden">
        <DefaultTimer
            v-for="(timer, index) in timers"
            :key="`main_layout_timer_${index}`"
            :label="timer.label"
            :expired-label="timer.expired_label"
            :background-color="timer.background_color"
            :start-date="timer.start_date"
            :end-date="timer.end_date"
        />
    </div>
</template>

<script setup lang="ts">
import DefaultTimer from '@/components/timers/DefaultTimer.vue';
import { useProductPageStore } from '@/stores/pages/ProductPageStore';
import { computed } from 'vue';

const productPageStore = useProductPageStore();
const timers = computed(() => productPageStore.configurableProduct.timers);
</script>
